import { useDispatch, useSelector } from "react-redux"
import axios from 'axios';
import style from './Search.module.scss'
import { setContent, setTotalCount } from "../../../redux/contentSlices/ContentSlices";
import { setSearch } from "../../../redux/headerSlices/HeaderSlices";
import { useRef } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { selectHeader } from '../../../redux/headerSlices/HeaderSelector'

let Search = () => {

    const dispatch = useDispatch()

    const { search } = useSelector(selectHeader)

    const inputRef = useRef<HTMLInputElement>(null)

    const onClickClear = () => {
        if (inputRef !== null) {
            dispatch(setSearch(''))
            inputRef.current?.focus()
        } else { console.log('Error') }
    }

    let SearchMovie = () => {
        axios.get(`https://yts.mx/api/v2/list_movies.json?quality=2160p&limit=24&minimum_rating=0&page=1&sort_by=like_count&order_by=desc&query_term=${search}`)
            .then(response => {
                try {
                    console.log(response)
                    if (response.data.data.movies) {
                        dispatch(setContent(response.data.data.movies))
                        dispatch(setTotalCount(response.data.data.movie_count))
                    } else {
                        alert(`No movie with the same name was found,try to lower the quality of the movie using a filter`)
                    }
                } catch (err) {
                    console.log(err)
                }
            })
    }

    let SearchKey = (event: React.KeyboardEvent<HTMLInputElement>) => {
        if (event.key === 'Enter') {
            SearchMovie()
        }
    }

    const onChangeSearch = (event: string) => {
        dispatch(setSearch(event))
    }

    return (
        <div className={style.Header__search} >
            <input ref={inputRef} value={search} placeholder='Search...' onKeyDown={SearchKey} onChange={(event) => onChangeSearch(event.target.value)} data-testid='search-element' />
            {search ? <ClearIcon sx={{ fontSize: 40 }} onClick={() => onClickClear()} /> : null}
        </div>
    )
}

export default Search;